import { useEffect, useState } from "react";
import "./AvatarRound.css"

function AvatarRound({ img, width, name }) {

    const [avatar, setAvatar] = useState(null);
    const [avatarName, setAvatarName] = useState(null);
    const [fontSize, setFontSize] = useState(18);

    useEffect(() => {
        if (img !== null & img !== undefined) {
            setAvatar(img);
        }
        if (width > 100) {
            setFontSize(50);
        }
        if (name !== null & name !== undefined) {
            setAvatarName(name.charAt(0));
        }
    }, [img, width, name]);

    return (
        <>
            {avatar === null ? (
                <div className="no_avatar" style={{ height: width, width: width, fontSize: fontSize, verticalAlign: 'middle' }}>{avatarName}</div>

            ) : (
                <img className="rounded-circle" width={width} src={process.env.REACT_APP_API_MAIN + '/file/avatar/' + avatar}></img>
            )}
        </>
    )
}

export default AvatarRound;
